
import { mapMutations } from "vuex";
import Datetime from 'vux/src/components/datetime/index.vue'

export default {
name: "App",
data() {
return {
psdPlaceholder:"请输入就诊卡号",
cxtype: '0',
code: "",
name: "",
startDate: '',
startGLDate: '',
endGLDate: ''
};
},
methods: {
dateConfirm1 (val) {
this.startGLDate = val
},
dateConfirm2 (val) {
this.endGLDate = val
},
showCodes(){
this.psdPlaceholder = this.cxtype=='0' ? "请输入就诊卡号" : this.cxtype=='1' ? "请输入住院号" : "请输入身份证号" ;
},
jump() {
if (!this.code && !this.name) {
this.$dialog({
title: "提示",
message: "请输入就诊卡号或患者姓名"
});
return false;
}
if (!this.startGLDate || !this.endGLDate) {
this.$dialog({
title: "提示",
message: "请选择开始日期及结束日期"
});
return false;
}
this.$request({
url: "/erpQuery/queryOrder",
data: {
patcode:this.code,
patname:this.name,
rqq:this.startGLDate,
rqz:this.endGLDate,
cxtype:this.cxtype,
invoiceStatus: "0"
}
}).then(res => {

if (!res) {
return;
}
this.setBillInfo(res)
this.$router.push({
path: "/invoiceList",
query: {
patcode:this.code,
patname:this.name,
cxtype:this.cxtype,
rqq:this.startGLDate,
rqz:this.endGLDate
}
});
});
},
...mapMutations("invoice", ["setBillInfo"]),
},
components: {
Datetime
}
};



// WEBPACK FOOTER //
// ./src/pages/cart-num/cart-num.vue